import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerHasEstimateApi.graphql';
import { Query, QueryinfluencerHasEstimateApiArgs } from '../../__generated__/globalTypes';

export const useInfluencerHasEstimateApiQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerHasEstimateApiArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerHasEstimateApiArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerHasEstimateApiLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerHasEstimateApiArgs>
): QueryResult<Query, QueryinfluencerHasEstimateApiArgs> & {
  getInfluencerHasEstimateApi: LazyQueryExecFunction<Query, QueryinfluencerHasEstimateApiArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerHasEstimateApi, result] = useLazyQuery<Query, QueryinfluencerHasEstimateApiArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerHasEstimateApi, ...result };
};

export const useInfluencerHasEstimateApiPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerHasEstimateApi = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerHasEstimateApiArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerHasEstimateApiArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerHasEstimateApi };
};
// Suspense Query Hooks
export const useInfluencerHasEstimateApiSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerHasEstimateApiArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerHasEstimateApiArgs>(QUERY, {
    ...options
  });

  return result;
};
